import { Fragment, useContext } from "react";

import { useTranslation } from "react-i18next";

import { InfoTooltip } from "components/Table/components";
import CardItemValue from "components/TableDetails/components/CardItemValue";
import SingleInfo from "components/TableDetails/components/TitleInfo/SingleInfo";
import TableContext from "context/table/tableContext";
import { Accessory } from "shared";

import { CARD_ITEMS, CARDS } from "../../types";
import { DetailsData } from "../types";

const Accessories = () => {
    const { detailsData } = useContext(TableContext);

    const {
        accessories: { data }
    }: DetailsData = detailsData;

    const { t } = useTranslation();

    const renderAccessories = (stringifiedData: string) => {
        try {
            const parsedData = JSON.parse(stringifiedData);

            return parsedData.map(({ Id, Type, Interface }: Accessory) => (
                <Fragment key={Id}>
                    <>
                        <span>{t(`Table##${CARD_ITEMS.Type}`)}:</span>
                        <CardItemValue value={Type} />
                    </>

                    <>
                        <span>{t(`Table##${CARD_ITEMS.Interface}`)}:</span>
                        <CardItemValue value={Interface} />
                    </>
                </Fragment>
            ));
        } catch {
            return null;
        }
    };

    const tooltipList = [CARD_ITEMS.Type, CARD_ITEMS.Interface];

    return (
        <div>
            <div>
                {t(`Table##${CARDS.Accessories}`)}

                <InfoTooltip
                    title={
                        <ul>
                            {tooltipList.map(tooltip => (
                                <SingleInfo
                                    key={tooltip}
                                    cardName={CARDS.Accessories}
                                    title={tooltip}
                                />
                            ))}
                        </ul>
                    }
                />
            </div>

            <div>{renderAccessories(data)}</div>
        </div>
    );
};

export { Accessories };
